import { useMemo } from 'react';
import VoltoRenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  hasBlocksData,
} from '@plone/volto/helpers/Blocks/Blocks';
// CUSTOM (govbr): import usado para aplicar correções/remoções de blocos antes de renderizar
import { applyBlockFixes } from 'govbr.frontend.policy/helpers/applyBlockFixes';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

/**
 * RenderBlocks view component class.
 * @function RenderBlocks
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
const RenderBlocks = ({
  content,
  exclude = ['title', 'description', 'dateSocialShareBlock'],
}) => {
  // CUSTOM (govbr): aplicar correções/remover blocos antes de renderizar o conteúdo
  const fixedBlocks = useMemo(() => applyBlockFixes(content), [content]);
  // CUSTOM (govbr): memoizar contentFixed para evitar nova referência a cada render
  const contentFixed = useMemo(
    () =>
      fixedBlocks === content?.blocks
        ? content
        : { ...content, blocks: fixedBlocks },
    [content, fixedBlocks],
  );

  /* Render text or blocks in view, skip title and description blocks by default*/
  const blocksFieldname = getBlocksFieldname(contentFixed);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(contentFixed);
  const location = useLocation();

  // CUSTOM (govbr): memoizar blocksLayoutFiltered para evitar recarregamentos desnecessários
  // ao passar o mouse sobre o bloco (hover), que causavam recarregamento de blocos de listagem
  const blocksLayoutFiltered = useMemo(() => {
    if (!hasBlocksData(contentFixed)) return [];

    if (!contentFixed[blocksLayoutFieldname]?.items?.length) return null;

    let filtered = contentFixed[blocksLayoutFieldname].items.filter((block) => {
      const blockType = contentFixed[blocksFieldname]?.[block]?.['@type'];
      return exclude.indexOf(blockType) < 0;
    });

    //è il caso in cui c'è solo il primo blocco di testo vuoto. Non si vuole renderizzare il <br/>
    if (filtered?.length === 1) {
      const block = contentFixed[blocksFieldname][filtered[0]];
      if (block['@type'] === 'text' && !block.text) {
        filtered = [];
      }
      if (block['@type'] === 'slate' && block.plaintext?.length === 0) {
        filtered = [];
      }
    }

    return filtered;
  }, [contentFixed, blocksFieldname, blocksLayoutFieldname, exclude]);

  // CUSTOM (govbr): memoizar contentWithFilteredBlocks para evitar nova referência a cada render
  const contentWithFilteredBlocks = useMemo(
    () => ({
      ...contentFixed,
      [blocksLayoutFieldname]: {
        ...contentFixed[blocksLayoutFieldname],
        items: blocksLayoutFiltered,
      },
    }),
    [contentFixed, blocksLayoutFieldname, blocksLayoutFiltered],
  );
  return blocksLayoutFiltered?.length > 0 ? (
    <VoltoRenderBlocks
      content={contentWithFilteredBlocks}
      location={location}
    />
  ) : null;
};

export default RenderBlocks;

RenderBlocks.propTypes = {
  content: PropTypes.any,
};
